
import { IServiceMap } from '@/business/BusinessFormData'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue } from 'vue-property-decorator'
import Template from '../components/Template.vue'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import XdocProjectPlan from '../components/XdocProjectPlan.vue'
import XdocProjectPlanForWord from '../components/XdocProjectPlanForWord.vue'
import _ from 'lodash'
import { editOrder } from '@/api/placeOrder'
import { Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { getDefaultForm } from '../helper'
import { ICustomerAppKey, IOrganization } from '@/store/state'

@Component({
  components: {
    BasePage,
    Template,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlan,
    XdocProjectPlanForWord,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  needAttachment = false
  needSeewo = false

  type = ''
  name = ''
  reEdit = false

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (this.form.material.type === 0 && !this.form.material.oss_fbd_zips?.length)
      return this.$message.error('请上传zip文件')
    if (!this.form.material.courseware_sample_files?.length) {
      this.$message.error('请上传样例课件、制作说明文件')
      return callback(true)
    }
    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    // 清除开发添加的字段
    for (const i of this.form.xdoc_planning) {
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(i.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }
      if (!i.origin_files!.filter(fbd => fbd.type === 1).length) {
        this.$message.error('制作内容中未选择正文fbd文件')
        return callback(true)
      }
      if (this.form.material.type !== 1 && !i.compare_pdf!.filter(pdf => pdf.type === 1).length) {
        this.$message.error('制作内容中未选择正文pdf文件')
        return callback(true)
      }

      if (i.config.fbd_type === 1 && this.form.material.type !== 1) {
        if (!i.origin_files!.filter(fbd => fbd.type === 0).length) {
          this.$message.error('制作内容中未选择答案fbd文件')
          return callback(true)
        }
        if (!i.compare_pdf!.filter(pdf => pdf.type === 0).length) {
          this.$message.error('制作内容中未选择答案pdf文件')
          return callback(true)
        }
      }
    }

    return callback(false)
  }

  async submit(formData: any) {
    // 是否需要附带信息
    if (this.needAttachment) {
      formData.xdoc_planning &&
        formData.xdoc_planning.map((projetct: any) => {
          if (projetct.config.delivery !== 1) {
            projetct.config.delivery = projetct.config.delivery === 0 ? 6 : projetct.config.delivery
          }
        })
    }
    // 是否需要希沃白板文件
    if (this.needSeewo) {
      formData.xdoc_planning &&
        formData.xdoc_planning.map((projetct: any) => {
          projetct.config.need_seewo = true
        })
    }
  }

  fileType = 0
  handleFileTypeChange(e: number) {
    if (e !== 2) {
      this.form.xdoc_planning = []
    }
    setTimeout(() => {
      this.$set(this.form.material, 'type', e)
      this.fileType = e
    }, 100)
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }

  async handleSaveForm() {
    await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
  }
}
